export default __webpack_public_path__ + "static/frame2-60a1ad8e78dfc1a34b1b12c0d16506b6.png";